import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("binarex_user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("binarex_token");
    if (!token) return;
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("binarex_user", JSON.stringify(data));
    } catch {
      setUser(null);
      localStorage.removeItem("binarex_token");
      localStorage.removeItem("binarex_user");
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("binarex_token", data.token);
      localStorage.setItem("binarex_user", JSON.stringify(data.user));
      setUser(data.user);
      return data.user;
    } finally {
      setLoading(false);
    }
  };

  const register = async (name, email, password, referral_code) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", { name, email, password, referral_code });
      localStorage.setItem("binarex_token", data.token);
      localStorage.setItem("binarex_user", JSON.stringify(data.user));
      setUser(data.user);
      return data.user;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem("binarex_token");
    localStorage.removeItem("binarex_user");
    setUser(null);
  };

  const loginWithToken = useCallback(async (token) => {
    localStorage.setItem("binarex_token", token);
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("binarex_user", JSON.stringify(data));
      return data;
    } catch {
      localStorage.removeItem("binarex_token");
      throw new Error("Token invalid");
    }
  }, []);

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh, setUser, loginWithToken }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
